export const emptyMarketingValues = {
  title: '', purpose: '', channels: '', materials: '', additional_details: '',
};

export interface MarketingDraft {
  id: string;
  values: typeof emptyMarketingValues;
  recipient: string;
  locale: string;
  attempted: boolean;
}

export function marketingDraftKey(adminId: string, athleteId: string) {
  return `evalyte.marketing.draft.v1:${adminId}:${athleteId}`;
}

export function readMarketingDraft(key: string): MarketingDraft | null {
  try {
    const saved = JSON.parse(sessionStorage.getItem(key) ?? 'null') as Partial<MarketingDraft> | null;
    if (!saved || typeof saved.id !== 'string' || !/^[\da-f-]{36}$/i.test(saved.id)
      || !saved.values || typeof saved.recipient !== 'string' || saved.recipient.length > 255
      || !['de', 'en'].includes(saved.locale ?? '')
      || !Object.keys(emptyMarketingValues).every((field) => {
        const value = saved.values?.[field as keyof typeof emptyMarketingValues];
        return typeof value === 'string' && value.length <= 2000;
      })) return null;
    return saved as MarketingDraft;
  } catch { return null; }
}
